module.exports = __webpack_public_path__ + "static/media/Team 28 - CELLVATION.6997e915.png";